'use client';
import { useEffect, useRef, useState } from 'react';
import { Box, Button, styled, Typography } from '@mui/material';

const CollapsibleContent = styled(Box)(
  ({ theme, maxHeight }: { theme: any; maxHeight: number }) => ({
    position: 'relative',
    overflow: 'hidden',
    transition: 'max-height 0.3s ease-in-out',
    '&.collapsed:after': {
      content: '""',
      position: 'absolute',
      top: `${maxHeight - 28}px`,
      right: 0,
      width: '100%',
      height: '26px',
      background: `linear-gradient(0deg, ${theme.palette.background.paper}, rgba(255, 255, 255, 0) 80%)`,
    },
  })
);

export default function ViewMore({ content, maxHeight = 96, fontSize = 16 }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    if (contentRef.current) {
      setShowButton((contentRef.current as any).scrollHeight > maxHeight);
    }
  }, [content, maxHeight]);

  return (
    <Box position="relative">
      {/* Full content for SEO (hidden from view) */}
      <Box sx={{ display: 'none' }}>
        <Typography dangerouslySetInnerHTML={{ __html: content }} />
      </Box>

      <CollapsibleContent
        ref={contentRef}
        className={
          !isExpanded && showButton ? 'collapsed view-more-collapsed' : ''
        }
        maxHeight={maxHeight}
        sx={{
          maxHeight: isExpanded ? 'none' : `${maxHeight}px`,
        }}
      >
        <Typography
          fontSize={fontSize}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </CollapsibleContent>

      {showButton && (
        <Box textAlign="right">
          <Button color="primary" onClick={() => setIsExpanded(!isExpanded)}>
            {isExpanded ? 'View less' : 'View more'}
          </Button>
        </Box>
      )}
    </Box>
  );
}
